// extracted by mini-css-extract-plugin
export default {"cls1":"JR23DdlMOOpPqEFr_dfJ","cls2":"OQ0H03L5Q_YUZX3jm2PM JR23DdlMOOpPqEFr_dfJ","bookingAppRedesign":"sx1BU5GToBNvC2vof7nV"};